import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-01-24 04:11:48 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159990 $
//  Purpose   : react components for debugging
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Table, Button, Header, Icon, Message, Label } from 'semantic-ui-react';
// ---Framework imports
import connect from 'uix/connect';
import { mapItems, rstrip, isString, size } from 'ldash';
import { uix, Actions } from 'uix/registries';
import log from 'uix/logging';
import { KNOWN_SERVERS, LOCAL_HOSTNAME } from 'uix/deploy';
import { HeaderSegment, XMenu } from 'uix/components';
import { useState, useSelector, useActions, useEffect } from 'uix/hooks';
// ---Local imports
// ---Globals
export const ServerChooser = ({ message, errors })=>{
    // debug actions
    let [getApiAvailability, switchApiUrl] = useActions([
        'getApiAvailability',
        'switchApiUrl'
    ]);
    let apiAvailability = useSelector((root)=>root.debug.apiAvailability);
    let [filter, setFilter] = useState('vis');
    let filtered_servers = KNOWN_SERVERS.filter((url)=>filter == '*' || filter.length > 2 && url.includes(filter));
    useEffect(()=>{
        getApiAvailability(filtered_servers);
    }, [
        filter
    ]);
    apiAvailability = apiAvailability || {};
    let availability = (url)=>{
        let bColor = 'grey';
        let iColor = 'grey';
        if (apiAvailability[url] == true) {
            iColor = 'green';
            bColor = 'green';
        } else if (apiAvailability[url] == false) {
            bColor = 'grey';
            iColor = 'red';
        }
        return /*#__PURE__*/ _jsxs(Button, {
            size: "small",
            color: bColor,
            basic: true,
            compact: true,
            onClick: ()=>switchApiUrl(url),
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    name: "plug",
                    color: iColor
                }),
                " ",
                url
            ]
        });
    };
    let ApiButton = ({ name, href })=>/*#__PURE__*/ _jsx(Button, {
            secondary: true,
            compact: true,
            size: "small",
            as: "a",
            href: href,
            target: "_api",
            content: name
        });
    let rows = (servers)=>servers.map((url)=>/*#__PURE__*/ _jsxs(Table.Row, {
                children: [
                    /*#__PURE__*/ _jsx(Table.Cell, {
                        children: availability(url)
                    }),
                    /*#__PURE__*/ _jsxs(Table.Cell, {
                        children: [
                            /*#__PURE__*/ _jsx(ApiButton, {
                                name: "init",
                                href: `${url}/api/init`
                            }),
                            /*#__PURE__*/ _jsx(ApiButton, {
                                name: "dconfig",
                                href: `${url}/api/initDomain/dconfig`
                            }),
                            /*#__PURE__*/ _jsx(ApiButton, {
                                name: "types",
                                href: `${url}/api/initDomain/types`
                            }),
                            /*#__PURE__*/ _jsx(ApiButton, {
                                name: "templating",
                                href: `${url}/api/initDomain/templating`
                            })
                        ]
                    })
                ]
            }, url));
    let ServerTable = ({ servers })=>/*#__PURE__*/ _jsx(Table, {
            celled: true,
            compact: true,
            size: "small",
            children: /*#__PURE__*/ _jsx(Table.Body, {
                children: rows(servers)
            })
        });
    let menu = /*#__PURE__*/ _jsx(XMenu, {
        borderless: true,
        children: /*#__PURE__*/ _jsx(XMenu.FilterInput, {
            autoFocus: true,
            title: "use * for all",
            defaultValue: filter,
            onValueChange: setFilter
        })
    });
    return /*#__PURE__*/ _jsx("div", {
        style: {
            padding: '2em',
            fontSize: '0.8rem'
        },
        children: /*#__PURE__*/ _jsxs(HeaderSegment, {
            icon: "fire extinguisher",
            header: message,
            subheader: `choose other Server for API - available: ${KNOWN_SERVERS.length}`,
            menu: menu,
            children: [
                size(errors) > 0 ? /*#__PURE__*/ _jsxs(Message, {
                    negative: true,
                    children: [
                        /*#__PURE__*/ _jsx(Message.Header, {
                            children: "Initialization errors"
                        }),
                        errors.map((err, i)=>/*#__PURE__*/ _jsx("p", {
                                children: err
                            }, i))
                    ]
                }) : null,
                filtered_servers.length ? /*#__PURE__*/ _jsx(ServerTable, {
                    servers: filtered_servers
                }) : /*#__PURE__*/ _jsx(Message, {
                    info: true,
                    children: "No instances filtered."
                })
            ]
        })
    });
};
